import { create } from 'zustand'

export const useThreadStatusStore = create((set, get) => ({
  generatingIds: new Set(),
  unreadIds: new Set(),

  setGenerating: (threadId, isGenerating) => {
    set((state) => {
      const next = new Set(state.generatingIds)
      if (isGenerating) {
        next.add(threadId)
      } else {
        next.delete(threadId)
      }
      return { generatingIds: next }
    })
  },

  markUnread: (threadId) => {
    set((state) => {
      if (state.unreadIds.has(threadId)) return state
      const next = new Set(state.unreadIds)
      next.add(threadId)
      return { unreadIds: next }
    })
  },

  markRead: (threadId) => {
    set((state) => {
      if (!state.unreadIds.has(threadId)) return state
      const nextUnread = new Set(state.unreadIds)
      nextUnread.delete(threadId)
      return { unreadIds: nextUnread }
    })
  },
}))
